// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Label from '../../../components/label';
import Iconify from '../../../components/iconify';
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog:  <Iconify icon="uim:blogger-alt" />,
  // blog: icon('ic_blog'),
  // bloglist: icon('ic_menu_item'),
  bloglist: <Iconify icon="material-symbols:view-list" />,
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  profile: icon('ic_profile'),
  setting: icon('ic_setting'),
  friends: <Iconify icon="eva:people-fill" />,
  logout: icon('ic_logout'),
  explore: <Iconify icon="eva:search-outline" />,
  // explore: <Iconify icon="material-symbols:search" />,
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      // { title: 'news', path: PATH_DASHBOARD.app, icon: ICONS.dashboard },
      // { title: 'news', path: PATH_DASHBOARD.app, icon: ICONS.dashboard },

      { title: 'news', path: PATH_DASHBOARD.news.root, icon: ICONS.dashboard },

      // { title: 'kanban', path: PATH_DASHBOARD.kanban, icon: ICONS.kanban },
      // { title: 'ecommerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
      // { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
      // { title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
      // { title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking },
      // { title: 'file', path: PATH_DASHBOARD.general.file, icon: ICONS.file },

      // {
      //   title: 'blog',
      //   path: PATH_DASHBOARD.blog.root,
      //   icon: ICONS.blog,
      //   children: [
      //     { title: 'posts', path: PATH_DASHBOARD.blog.posts },
      //     { title: 'list', path: PATH_DASHBOARD.myblog.root },
      //     // { title: 'post', path: PATH_DASHBOARD.blog.demoView },
      //     { title: 'create', path: PATH_DASHBOARD.blog.new },
      //   ],
      // },

      { title: 'explore', path: PATH_DASHBOARD.explore, icon: ICONS.explore },
      { title: 'blog', path: PATH_DASHBOARD.blog.posts, icon: ICONS.blog },
      { title: 'My blog', path: PATH_DASHBOARD.myblog.root, icon: ICONS.bloglist },
      // { title: 'explore', path: PATH_DASHBOARD.explore, icon: ICONS.explore },

      // { title: 'friends', path: PATH_DASHBOARD.friends, icon: ICONS.friends },
      { title: 'profile', path: PATH_DASHBOARD.profile, icon: ICONS.profile },
      { title: 'setting', path: PATH_DASHBOARD.setting, icon: ICONS.setting },
      { title: 'logout', path: PATH_DASHBOARD.logout, icon: ICONS.logout },
    ],
  },

  // {
  //   subheader:'settings',
  //   items: [
  //     {
  //       title: 'blog',
  //       path: PATH_DASHBOARD.blog.root,
  //       icon: ICONS.blog,
  //       children: [
  //         { title: 'posts', path: PATH_DASHBOARD.blog.posts },
  //         // { title: 'post', path: PATH_DASHBOARD.blog.demoView },
  //         { title: 'create', path: PATH_DASHBOARD.blog.new },
  //       ],
  //     },
  //   ],
  // }

  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'management',
  //   items: [
  //     {
  //       title: 'user',
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: 'Four', path: PATH_DASHBOARD.user.four },
  //         { title: 'Five', path: PATH_DASHBOARD.user.five },
  //         { title: 'Six', path: PATH_DASHBOARD.user.six },
  //       ],
  //     },
  //   ],
  // },
];

export default navConfig;
